import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { MobMaskModule } from "../../directives/mob-mask/mob-mask.module";
import { RequestSupportComponent } from "./request-support.component";


@NgModule({
  declarations: [RequestSupportComponent],
  imports: [
    CommonModule,
    NgbNavModule,
    NgSelectModule,
    MobMaskModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports:[RequestSupportComponent]
})
export class RequestSupportModule { }
